// Identificación de entorno centralizada de Asset Passport.
// Única fuente de verdad para distinguir preview / producción / desarrollo local.

export const APP_HOST = typeof window !== "undefined" ? window.location.hostname : "";
export const APP_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

// Preview = cualquier host de la plataforma de desarrollo. Producción = assetpassport.io.
export const IS_PREVIEW_HOST = /(^|\.)emergentagent\.com$/.test(APP_HOST);
export const IS_LOCAL_DEV = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(APP_ORIGIN);
export const ENV_LABEL = IS_PREVIEW_HOST ? "preview" : IS_LOCAL_DEV ? "desarrollo local" : "producción";

// Identificador del build cargado (hash del bundle CRA en producción; "dev" con dev-server).
export const BUILD_ID = (() => {
  if (typeof document === "undefined") return "dev";
  const script = document.querySelector('script[src*="/static/js/main."]');
  const match = script?.getAttribute("src")?.match(/main\.([a-f0-9]+)\.js/);
  return match ? match[1] : "dev";
})();

export const PREVIEW_BANNER_TEXT =
  "Entorno de desarrollo (preview) — los datos aquí no son los de producción (assetpassport.io)";
